enum IntegrationResultStatusEnum {
  Unknown = 0,
  Success = 1 << 0,
  OibFailed = 1 << 1,
  BirthRegistryFailed = 1 << 2,
  MupFailed = 1 << 3,
}

export default IntegrationResultStatusEnum;
